/*
 * ---------------------------------------------------------------
 * ## HAND-WRITTEN STAND-IN FOR A SWAGGER-GENERATED CLIENT       ##
 * ##                                                           ##
 * ## The media-plan version routes (AAD-3567) are not on a      ##
 * ## deployed backend yet, so `yarn generate:api-*` cannot emit ##
 * ## them on the MediaPlans class. This mirrors the generated   ##
 * ## shape exactly (extends HttpClient, `this.request`,         ##
 * ## `secure: true`) and lives outside `src/api/` only because  ##
 * ## that folder is git-ignored and wiped on regeneration. Once ##
 * ## the backend ships, delete this file and re-point the       ##
 * ## imports at the regenerated `@/api/MediaPlans` methods.     ##
 * ---------------------------------------------------------------
 */
import { AuditResponse, MediaPlan, MediaPlanResponse } from '@/api/data-contracts';
import { ContentType, HttpClient, RequestParams } from '@/api/http-client';

export type MediaPlanVersionRow = MediaPlanResponse & {
  versionNumber: number;
  versionGroupId?: string;
};

export class MediaPlanVersions<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @name DuplicateAsVersion
   * @request POST:/mediaPlans/{planId}/versions
   * @secure
   */
  duplicateAsVersion = (
    planId: string,
    data: MediaPlan,
    query?: { number?: number },
    params: RequestParams = {},
  ) =>
    this.request<MediaPlanResponse, void>({
      path: `/mediaPlans/${planId}/versions`,
      method: 'POST',
      query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  /**
   * @name ListVersions
   * @request GET:/mediaPlans/{planId}/versions
   * @secure
   */
  listVersions = (planId: string, params: RequestParams = {}) =>
    this.request<MediaPlanVersionRow[], void>({
      path: `/mediaPlans/${planId}/versions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });

  /**
   * @name GroupHistory
   * @request GET:/mediaPlans/{planId}/versions/history
   * @secure
   */
  groupHistory = (planId: string, params: RequestParams = {}) =>
    this.request<AuditResponse[], void>({
      path: `/mediaPlans/${planId}/versions/history`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
